import { useState } from 'react';
import { shuffle as shuffleItems } from 'lodash';

export type ShuffledOrder<T> = {
  // The items in their shuffled order, or as given while not shuffled
  items: T[];
  isShuffled: boolean;
  shuffle: () => void;
  reset: () => void;
};

// Shuffles items a panel has already fetched, and puts them back in the order they came in. New items
// (a new fetch) start unshuffled. `arrange` runs on each shuffled order, e.g. to renumber it.
export const useShuffledOrder = <T>(items: T[], arrange: (shuffled: T[]) => T[] = (shuffled) => shuffled): ShuffledOrder<T> => {
  // Remembers which items were shuffled, so the shuffle is dropped once they are replaced
  const [shuffled, setShuffled] = useState<{ from: T[]; items: T[] }>(null);
  const isShuffled = !!shuffled && shuffled.from === items;

  return {
    items: isShuffled ? shuffled.items : items,
    isShuffled,
    shuffle: () => setShuffled({ from: items, items: arrange(shuffleItems(items)) }),
    reset: () => setShuffled(null),
  };
};
